export default __webpack_public_path__ + "static/media/245.92edd041.jpg";